import { createFileRoute } from "@tanstack/react-router";
import InfographicLandingPage from "@/site/pages/infographic-landing";

export const Route = createFileRoute("/infographic")({
  component: InfographicLandingPage,
});
